<p-datepicker
  [formControl]="ctrl"
  [showClear]="formField.clearable"
  [placeholder]="formField.placeholder"
  [readonlyInput]="formField.readonlyInput"
  [timeOnly]="true"
  [required]="!!formField.required"
  [autofocus]="formField.autofocus"
/>
